import { render, staticRenderFns } from "./interactionIndex.vue?vue&type=template&id=23a27f33&"
import script from "./interactionIndex.vue?vue&type=script&lang=js&"
export * from "./interactionIndex.vue?vue&type=script&lang=js&"
import style0 from "./interactionIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports